<template>
	<div class="landing-gift">
		<div class="landing-gift__icon">
			<img src="@/assets/landing/alert-gift.png" alt="" />
		</div>
		<div class="landing-gift__text">
			Take the quiz and get your
			<span>personal plan</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LandingGift',
}
</script>

<style lang="scss" scoped>
.landing-gift {
	display: flex;
	align-items: center;
	background-color: var(--Fill-Accent-16);
	border-radius: var(--size-16);
	padding: var(--size-16) var(--size-20);
	margin-bottom: var(--size-16);
	font-size: var(--size-18);
	line-height: var(--size-22);
	font-weight: 600;
	gap: var(--size-20);
	padding-right: var(--size-52);

	&__icon {
		width: 56px;
		flex-shrink: 0;
	}

	&__text {
		span {
			color: var(--Text-Accent);
		}
	}
}
</style>
